import React from 'react';
import WorkoutsDisplay from '../../../components/workoutsDisplay';
import displaySectionStyle from './style';
import WarningBlock from '../../../components/highlightedBlock';
import InfoBlock from '../../../components/infoBlock';

export default function DisplaySection() {
	let style = displaySectionStyle();
	return (
		<div style={style.outerStyle()}>
			<h1 style={style.titleStyle()}>Workout Programs already made for you!</h1>
			<WorkoutsDisplay />
			<WarningBlock
				mt={true}
				texts={[
					'Note: The programs provided are 8-12 weeks long and require repetition and consistency. (Please look to the “Arsenal” for different exercises to replace then perform.)',
				]}
			/>
			<InfoBlock
				mt={true}
				texts={[
					'Please email brugmethod@gmail.com to get updated programs, exercises, custom personal workout plans, or nutrition advising.',
				]}
			/>
		</div>
	);
}
